import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'mm-image-compare',
  templateUrl: './image-compare.component.html',
  styleUrls: ['./image-compare.component.scss'],
})
export class ImageCompareComponent implements AfterViewInit {
  @Input() left!: string;
  @Input() right!: string;

  @Input() leftAlt: string = '';
  @Input() rightAlt: string = '';

  @Input() width?: string;
  @Input() height?: string;

  @Input() justifyself?: string = 'center';

  @ViewChild('divider') divider!: ElementRef<HTMLDivElement>;
  @ViewChild('leftImg') leftImg!: ElementRef<HTMLImageElement>;
  @ViewChild('rightImg') rightImg!: ElementRef<HTMLImageElement>;

  ngAfterViewInit() {
    if (this.width) {
      this.leftImg.nativeElement.width = +this.width;
      this.rightImg.nativeElement.width = +this.width;
    }
    if (this.height) {
      this.leftImg.nativeElement.height = +this.height;
      this.rightImg.nativeElement.height = +this.height;
    }

    const divider = this.divider.nativeElement;
    const wrapper = divider.parentElement!;

    const updatePosition = (xRaw: number) => {
      const rect = wrapper.getBoundingClientRect();
      const min = 22;
      const max = rect.width - 26;
      const x = Math.max(min, Math.min(max, xRaw));

      divider.style.left = x + 'px';
      wrapper.style.setProperty('--clip', x + 'px');
    };

    const rect = wrapper.getBoundingClientRect();
    const startX = rect.width / 2;
    divider.style.transition = 'left 0.6s ease';
    wrapper.style.transition = 'clip-path 0.6s ease';
    updatePosition(startX);

    setTimeout(() => {
      divider.style.transition = '';
      wrapper.style.transition = '';
    }, 600);

    wrapper.addEventListener('mousemove', (e: MouseEvent) => {
      updatePosition(e.clientX - rect.left);
    });

    wrapper.addEventListener('click', (e: MouseEvent) => {
      updatePosition(e.clientX - rect.left);
    });

    wrapper.addEventListener('touchmove', (e: TouchEvent) => {
      const touch = e.touches[0];
      updatePosition(touch.clientX - rect.left);
    });
  }
}

